// extracted by mini-css-extract-plugin
export default {"menuItem":"G8ftTn28EI6HqLRe3iE5uA=="};